import React from "react"
import ReactDOM from "react-dom"
import { App } from "./App"
import { createGlobalStyle } from "styled-components"
import "@theguarantors/ui-kit-v2/dist/assets/fonts/fonts.css"
import { theme } from "@theguarantors/ui-kit-v2/dist/design-system"
import { initSentry } from "@theguarantors/frontend-utils"

initSentry({
  application: "lg-questionnaire-v2",
  config: { dsn: process.env.REACT_APP_SENTRY_DSN },
  environment: process.env.REACT_APP_ENV,
})

const GlobalStyle = createGlobalStyle`
  *, *:after, *:before {
    box-sizing: border-box;
  }

  html {
    font-size: 10px;
  }

  body {
    padding: 0;
    margin: 0;
    max-width: 100vw;
    font-family: ${theme.fonts.acid};
    font-size: 1.6rem;
    letter-spacing: -.01em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    line-height: 2.4rem;
    
    @media (min-width: 768px) {
      line-height: 2.6rem;
    }
  }
`

ReactDOM.render(
  <>
    <GlobalStyle />
    <App />
  </>,
  document.getElementById("root")
)
